import { fontSize, primarySemiBoldFont, theme } from '@noths/polaris-client-ribbons-base';
import { hideScrollbar, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, text } = theme;

export const breadcrumbList = css`
  margin: 0;
  list-style-type: none;
  padding: 0;
  white-space: nowrap;
  overflow: scroll;

  ${hideScrollbar}
`;

export const breadcrumbNav = css`
  position: relative;

  &[data-left-fade-visible='true'] {
    &:before {
      content: '';
      position: absolute;
      width: ${pxToRem(spacing.xxl)};
      height: 100%;
      left: 0;
      top: 0;
      background-image: linear-gradient(
        to left,
        rgba(255, 255, 255, 0.3),
        rgba(255, 255, 255) 100%
      );
    }
  }
`;

export const breadcrumbListItem = css`
  display: inline-block;

  & + li::before {
    border-right: ${pxToRem(1)} solid var(--neutral-black-base);
    content: '';
    display: inline-block;
    height: ${pxToRem(12)};
    margin: 0 ${pxToRem(spacing.xs)};
    position: relative;
    top: 2px;
    transform: rotate(15deg);
  }

  &:last-child {
    ${fontSize(text.BODY.XS)}
    ${primarySemiBoldFont};
    color: var(--neutral-black-base);
  }
`;

export const breadcrumbLink = css`
  ${fontSize(text.BODY.XS)}
  text-decoration: none;
  color: var(--brand-purple-base-high-contrast);
  &[aria-current='page'] {
    font-weight: bold;
    color: var(--neutral-black-base);
  }
`;
